import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { Link } from "react-router-dom";
import Divider from "@material-ui/core/Divider";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/footer";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import Button from "@material-ui/core/Button";
import "../notes/notes.css";
import "./project.css";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary
  }
}));

export default function FullWidthGrid() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Navbar />
      <Link id="back" to="/">
        <Button
          style={{ margin: "10px", marginTop: "80px" }}
          variant="contained"
          color="primary"
          href="#contained-buttons"
        >
          <KeyboardBackspaceIcon />
        </Button>
      </Link>
      <Grid id="topgrid" container spacing={2} style={{ padding: "10px" }}>
        <Grid item xs={12}>
          <Paper
            style={{ backgroundColor: "#26A65B", color: "white" }}
            className={classes.paper}
          >
            Select your C.S.E semester
          </Paper>
        </Grid>

        <Grid item xs={6} sm={3} md={4}>
          <Link to="/5thSemProject" id="lnk">
            <Paper
              style={{ color: "white", textShadow: "black" }}
              id="projects"
              className={classes.paper}
            >
              5th sem
              <Divider style={{ backgroundColor: "white" }} />
              <p style={{ color: "white", textShadow: "black" }} id="Ttag">
                DBMS Project guide
              </p>
            </Paper>
          </Link>
        </Grid>
        <Grid item xs={6} sm={3} md={4}>
          <Link to="/6thSemProject" id="lnk">
            <Paper
              style={{ color: "white", textShadow: "black" }}
              id="projects"
              className={classes.paper}
            >
              6th sem
              <Divider style={{ backgroundColor: "white" }} />
              <p style={{ color: "white", textShadow: "black" }} id="Ttag">
                Computer Graphics project guide
              </p>
            </Paper>
          </Link>
        </Grid>
        <Grid item xs={6} sm={3} md={4}>
          <Link to="/7thSemProject" id="lnk">
            <Paper
              style={{ color: "white", textShadow: "black" }}
              id="projects"
              className={classes.paper}
            >
              7th sem
              <Divider style={{ backgroundColor: "white" }} />
              <p style={{ color: "white", textShadow: "black" }} id="Ttag">
                Web Development guide
              </p>
            </Paper>
          </Link>
        </Grid>
        <Grid item xs={6} sm={3} md={4}>
          {/* <Link to="/8thSemProject" id="lnk"> */}
          <Link to='/Notfound'  id='lnk'>
            <Paper
              style={{ color: "white", textShadow: "black" }}
              id="projects"
              className={classes.paper}
            >
              Final Year Project
              <Divider style={{ backgroundColor: "white" }} />
              <p style={{ color: "white", textShadow: "black" }} id="Ttag">
                A Unique conncept
              </p>
            </Paper>
          </Link>
        </Grid>

        <Grid item xs={12} sm={3} md={8}>
          <Link to="/Buyprojects" id="lnk">
            <Paper
              id="sell"
              style={{ textShadow: "black", marginTop: "-20px" }}
            >
              <h1 id="sellbanner">BUY C.S.E PROJECTS HERE</h1>
              <Divider style={{ backgroundColor: "white" }} />
              <p style={{ color: "white", textShadow: "black" }} id="Ttag">
                5th sem DBMS project Available
              </p>
              <p style={{ color: "white", textShadow: "black" }} id="Ttag">
                6th sem C.G project Available
              </p>
              <p style={{ color: "white", textShadow: "black" }} id="Ttag">
                7th sem WEB project Available
              </p>
              <Divider style={{ backgroundColor: "white" }} />
              <p
                style={{
                  color: "white",
                  textShadow: "black",
                  textAlign: "left",
                  padding: "5px"
                }}
                id="Ttag"
              >
                Contact : +91 9591379239 (whatsApp Available) <br />
                Email : viewnotes19@gmail.com
              </p>
              <p
                id="sellbanner"
                style={{
                  color: "white",
                  textShadow: "black",
                  textAlign: "left",
                  padding: "5px"
                }}
              >
                Projects are in limited quantity, contact soon.
              </p>

              <p
                style={{
                  color: "white",
                  textShadow: "black",
                  fontSize: "10px"
                }}
                id="Ttag"
              >
                Click on this banner for more information
              </p>
            </Paper>
          </Link>
        </Grid>
      </Grid>
     
      <Footer />
    </div>
  );
}
